// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"Parameter_selectWrapper__L5ir3"};